module.exports = __webpack_public_path__ + "static/media/PRODUTO_X_CULTURA_X_PERÍODO.53d4aea3.svg";